import { render } from "./App.vue?vue&type=template&id=251336fb"
const script = {}

import "./App.vue?vue&type=style&index=0&id=251336fb&lang=stylus"

import exportComponent from "E:\\Web\\Vue3\\TypeScript\\wallpaper\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__